import React, { forwardRef } from 'react';
import classNames from 'classnames';

import Icons from 'assets/icons';

interface EmptySpaceContentProps {
  image?: React.ReactNode;
  text?: React.ReactNode;
  linkShow?: boolean | null;
  linkText?: string | null;
  onClick?: () => void;
  customClass?: string;
  rotation?: 'vertical' | 'horizontal';
}

const EmptySpaceContent = forwardRef<HTMLDivElement, EmptySpaceContentProps>(
  (
    {
      image,
      text,
      linkShow = null,
      linkText = null,
      onClick,
      customClass = '',
      rotation = 'vertical',
    },
    _ref
  ) => (
    <div
      className={classNames(
        'flex justify-center items-center font-large text-center rounded-md bg-navy-50 relative h-[55vh]',
        customClass
      )}
      data-testid="empty-space-content"
    >
      <div
        className={classNames(
          'flex items-center font-family-[Barlow] font-semibold',
          {
            'flex-col': rotation === 'vertical',
            'flex-row gap-6': rotation === 'horizontal',
          }
        )}
      >
        <div
          className="animate-bounce-in"
          data-testid="empty-space-content-image"
        >
          {image}
        </div>

        <span
          className={classNames('text-gray-600 animate-fade-in', {
            'mt-[50px]': rotation === 'vertical',
          })}
          data-testid="empty-space-content-text"
        >
          {text}
        </span>

        {linkShow && (
          <button
            type="button"
            className={classNames('flex items-center bg-transparent border-0', {
              'mt-6 pb-6': rotation === 'vertical',
              'ml-4': rotation === 'horizontal',
            })}
            onClick={onClick}
            data-testid="empty-space-content-link"
          >
            <span className="text-navy-800">{linkText}</span>
            <Icons.Arrow customClass="ml-2 text-navy-800 font-semibold" aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  )
);

export default EmptySpaceContent;
